import { Instagram, Mail, ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { scrollToId } from "@/App";

export default function Contact() {
  return (
    <section id="contact" className="relative py-28 lg:py-40 overflow-hidden" data-testid="contact-section">
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(ellipse 55% 45% at 50% 60%, rgba(197,160,89,0.09), transparent 65%)",
        }}
      />
      <div className="max-w-4xl mx-auto px-5 sm:px-8 text-center relative">
        <Reveal>
          <p className="font-mono text-[10px] sm:text-xs tracking-[0.4em] uppercase text-gold/80">
            Contact
          </p>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-6 font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-ivory text-balance">
            Votre garde-temps vous attend
            <br />
            <span className="italic text-gold">peut-être déjà.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-8 text-base sm:text-lg text-stone2 leading-relaxed max-w-xl mx-auto">
            Décrivez-nous votre recherche. Nous nous chargeons d'activer nos connexions.
          </p>
        </Reveal>
        <Reveal delay={0.3}>
          <button
            onClick={() => scrollToId("demande")}
            className="mt-11 group relative bg-gold text-obsidian px-10 py-4 text-[12px] sm:text-[13px] tracking-[0.25em] uppercase font-medium overflow-hidden transition-transform duration-500 hover:-translate-y-0.5"
            data-testid="contact-cta-button"
          >
            <span className="relative z-10">Faire une demande</span>
            <span className="absolute inset-0 bg-gold-light translate-y-full group-hover:translate-y-0 transition-transform duration-500 ease-out" />
          </button>
        </Reveal>
        <Reveal delay={0.4}>
          <div className="mt-14 flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-10">
            <a
              href="https://instagram.com/babylon.private"
              target="_blank"
              rel="noreferrer"
              className="flex items-center gap-2.5 text-sm text-stone2 hover:text-gold transition-colors duration-300"
              data-testid="contact-instagram-link"
            >
              <Instagram size={16} strokeWidth={1.5} />
              @babylon.private
              <ArrowUpRight size={13} strokeWidth={1.5} className="opacity-50" />
            </a>
            <span className="hidden sm:block w-px h-4 bg-white/10" />
            <a
              href="mailto:Quentin.pontif@gmail.com"
              className="flex items-center gap-2.5 text-sm text-stone2 hover:text-gold transition-colors duration-300"
              data-testid="contact-email-link"
            >
              <Mail size={16} strokeWidth={1.5} />
              Quentin.pontif@gmail.com
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
